import { ReactComponent as UndoSvg } from './icons/tool-icon/undo.svg';
import { ReactComponent as RedoSvg } from './icons/tool-icon/redo.svg';
import { ReactComponent as LayerSvg } from './icons/tool-icon/layer.svg';
import { ReactComponent as FontSvg } from './icons/tool-icon/font.svg';
import { ReactComponent as DeleteSvg } from './icons/tool-icon/delete.svg';
import { ReactComponent as CopySvg } from './icons/tool-icon/copy.svg';
import { ReactComponent as MirrorSvg } from './icons/tool-icon/mirror.svg';
import { ReactComponent as RecArraySvg } from './icons/tool-icon/rec-array.svg';
import { ReactComponent as ArcArraySvg } from './icons/tool-icon/arc-array.svg';
import { ReactComponent as NoShowSvg } from './icons/tool-icon/no-show.svg';
import { ReactComponent as NoCodeSvg } from './icons/tool-icon/no-code.svg';
import { ReactComponent as ShowSvg } from './icons/tool-icon/show.svg';
import { ReactComponent as ArrowSvg } from './icons/tool-icon/arrow.svg'
import { ReactComponent as MonitorObjectSvg } from './icons/tool-icon/monitor-object.svg'
import { ReactComponent as LinkSvg } from './icons/tool-icon/link.svg'
import { ReactComponent as UcsSvg } from './icons/ucs/ucs.svg'
import { Layer } from '@/global/interface/layer';
import "./index.less"
import ColorChange from '@/global/components/color/ColorChange';
import { graphicStore } from '@/global/store/graphic-store';
import { AxisT, ModelBase, ToggleDrawColorCommand, ToggleEntityColorCommand, ToggleUcsCommand, UpdatePrimitivesCommand } from 'pytha';
import { useContext, useEffect, useState } from 'react';
import { Select } from 'antd';
import { DragModal } from 'tncet-common';
import LayerManage from '@/global/components/layer/LayerManage';
import UcsManage from '@/global/components/ucs/UcsManage';
import { ARCHIBASE_SINGAL } from '@/passets/archibase-engine/enums/archibase-singal';
import { useParams } from 'react-router';
import { findLayersInProjectUuid } from '@/api/geometry/layer';
import classNames from 'classnames';
import { SystemStatus } from '@/global/store/system-store';
import { CommonTabbarContext, SystemContext } from '@/App';
import { CommonTabbarState } from '@/global/components/common-tabbar';
import { TAB_TYPE } from '@/enums/tab-type';

export default function DrawTool() {

    const [currentColor, setCurrentColor] = useState(null);
    const [isColorByLayer, setIsColorByLayer] = useState(true);
    const [showLayerManage, setShowLayerManage] = useState<boolean>(false);
    const [currentLayerUuid, setCurrentLayerUuid] = useState<string>('');
    const [showUcsManage, setShowUcsManage] = useState<boolean>(false);
    const { projectId } = useParams()
    const [, setUpdateKey] = useState<string>("")
    const systemContext = useContext<SystemStatus>(SystemContext);
    const commonTabbarContext = useContext<CommonTabbarState>(CommonTabbarContext);

    useEffect(() => {
        setTimeout(() => {
            setUpdateKey("update")
        }, 5000)
    }, [])

    useEffect(() => {
        findLayersInProjectUuid(projectId).then(res => {
            let resLayer: Layer[] = res.data || [];
            let originLayer = resLayer.find((layer) => layer.originLayer && layer.projectUuid == projectId);
            if (originLayer != null) {
                setCurrentLayerUuid(originLayer.uuid)
            }
        })
    }, [graphicStore?.extraContext])

    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return () => { };
        // 注册图元选择
        graphicStore.extraContext.listeners.signals.onSelectChanged.add(onSelectChanged);

        return () => {
            if (!graphicStore.extraContext.getCurrentViewEditor()) return;
            graphicStore.extraContext.listeners.signals.onSelectChanged.remove(onSelectChanged);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    const onSelectChanged = (entities) => {
        let editor = graphicStore?.extraContext?.getCurrentViewEditor()
        if (editor) {
            let selects = editor.selectControl.getSelectedEntityList()
            if (selects?.length > 0) {
                setCurrentLayerUuid(selects[selects.length - 1].layerUuid)
            } else {
                setCurrentLayerUuid(graphicStore.context.layerContext.currentLayerUuid)
            }
        }
    }

    const handleChangeColor = (color) => {
        let oldColor = currentColor;
        let oldIsColorByLayer = isColorByLayer;
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        let editor = graphicStore.extraContext.getCurrentViewEditor();
        let selects = editor.selectControl.getSelectedEntityList();
        if (selects.length === 0) {

            editor.history.execute(new ToggleDrawColorCommand({
                color: color,
                isColorByLayer: false,
            }, {
                color: oldColor,
                isColorByLayer: oldIsColorByLayer,
            }))

        } else {
            editor.history.execute(new ToggleEntityColorCommand(selects, color, false));
        }
        editor.listeners.signals.onColorChanged.dispatch();
        setCurrentColor(color);
        setIsColorByLayer(false);
    }

    const handleColorByLayer = () => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        let oldIsColorByLayer = isColorByLayer;
        let editor = graphicStore.extraContext.getCurrentViewEditor();
        let selects = editor.selectControl.getSelectedEntityList();
        let color = graphicStore.context.layerContext.currentLayerColor;
        if (selects.length === 0) {
            editor.history.execute(new ToggleDrawColorCommand({
                color: color,
                isColorByLayer: true,
            }, {
                color: graphicStore.context.layerContext.currentColor,
                isColorByLayer: oldIsColorByLayer,
            }));
        } else {
            editor.history.execute(new ToggleEntityColorCommand(selects, color, true));
        }
        editor.listeners.signals.onColorChanged.dispatch();
        setCurrentColor(color);
        setIsColorByLayer(true);
    }

    const onLayerChange = (layerUuid) => {
        let curLayer = graphicStore.context.layerContext.layers.find(item => item.uuid === layerUuid);
        graphicStore.context.layerContext.currentLayerUuid = layerUuid;
        graphicStore.context.layerContext.currentLayerColor = curLayer.color;
        graphicStore.context.layerContext.currentColor = curLayer.color;
        setCurrentLayerUuid(layerUuid);
        // 选中的图元
        let selectedEntities: ModelBase[] = graphicStore.extraContext.getCurrentViewEditor().selectControl.getSelectedEntityList();
        if (!selectedEntities || selectedEntities?.length === 0) {
            return;
        }
        let changeEntities = selectedEntities?.map(item => {
            item.layerUuid = layerUuid;
            return item;
        })
        new UpdatePrimitivesCommand(selectedEntities, changeEntities).execute();
    }

    const onUcsChange = (ucsUuid) => {
        if (ucsUuid == null) return;
        let ucs = graphicStore?.context?.ucsContext?.ucsList?.find((ucs: AxisT) => ucs.uuid === ucsUuid);
        if (ucs == null) return;
        graphicStore.extraContext.getCurrentViewEditor().history.execute(new ToggleUcsCommand(ucs));
    }

    const onClickActiveControl = (cmd: string) => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
    }

    const activeArrayControl = (type: string) => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch("ARRAY");
        if (type == "rec") {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(ARCHIBASE_SINGAL.initArrayControl).dispatch("R")
        } else if (type == "arc") {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(ARCHIBASE_SINGAL.initArrayControl).dispatch("PO")
        }
    }

    // 显示/关闭监测对象图元
    const showMonitorObjectEntities = () => {
        systemContext.setShowMonitorObjectEntities(!systemContext.showMonitorObjectEntities);
    }

    return (
        <div className="draw-tool">
            <div className="tool-item">
                <UndoSvg className='icon' />
            </div>
            <div className="tool-item">
                <RedoSvg className='icon' />
            </div>
            <div className='layer-select-container'>
                <div className='layer-icon' onClick={() => {
                    setShowLayerManage(true);
                    if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
                    graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.emptySelectedEntities.dispatch();
                }}>
                    <LayerSvg />
                </div>
                <Select
                    style={{ width: '132px' }}
                    size="small"
                    suffixIcon={<ArrowSvg />}
                    // value={graphicStore?.context?.layerContext?.currentLayerUuid}
                    value={currentLayerUuid}
                    dropdownAlign={{
                        points: ['tc', 'bc'],
                        offset: [0, 0],
                        overflow: { adjustY: 0, adjustX: 0 },
                    }}
                    onChange={(e) => onLayerChange(e)}
                >
                    {graphicStore?.context?.layerContext?.layers?.map((layer: any, key) => (
                        <Select.Option value={layer?.uuid} key={layer?.uuid}>{layer?.name}</Select.Option>
                    ))}
                </Select>
            </div>
            {/* TODO: 线型选择框 */}
            <div className='ucs-select-container'>
                <div className='ucs-icon' onClick={() => setShowUcsManage(true)}>
                    <UcsSvg />
                </div>
                <Select
                    style={{ width: '132px' }}
                    size="small"
                    suffixIcon={<ArrowSvg />}
                    value={graphicStore?.context?.ucsContext?.currentUcs?.uuid}
                    dropdownAlign={{
                        points: ['tc', 'bc'],
                        offset: [0, 0],
                        overflow: { adjustY: 0, adjustX: 0 },
                    }}
                    onChange={(e) => onUcsChange(e)}
                >
                    {graphicStore?.context?.ucsContext?.ucsList?.sort((a, b) => (b.isWcs ? 1 : 0) - (a.isWcs ? 1 : 0))?.map((ucs: any, key) => (
                        <Select.Option value={ucs?.uuid} key={key}>{ucs?.name}</Select.Option>
                    ))}
                </Select>
            </div>
            <ColorChange
                editor={graphicStore?.extraContext?.getCurrentViewEditor()}
                selectColor={(color) => { handleChangeColor(color); }}
                selectByLayer={() => handleColorByLayer()}
            />
            <div className="tool-item" onClick={() => { onClickActiveControl("DT") }}>
                <FontSvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { onClickActiveControl("DELETE") }} >
                <DeleteSvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { onClickActiveControl("COPY") }} >
                <CopySvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { onClickActiveControl("MIRROR") }} >
                <MirrorSvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { activeArrayControl("rec") }} >
                <RecArraySvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { activeArrayControl("arc") }} >
                <ArcArraySvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { onClickActiveControl("AA") }}>
                <ShowSvg className='icon' />
            </div>
            <div className="tool-item" onClick={() => { onClickActiveControl("HIDDEN") }} >
                <NoShowSvg className='icon' />
            </div>
            <div className="tool-item">
                <NoCodeSvg className='icon' />
            </div>
            <div className={classNames({
                "tool-item": true,
                "selected": systemContext.showMonitorObjectEntities,
            })} onClick={() => showMonitorObjectEntities()}>
                <MonitorObjectSvg className='icon' />
            </div>
            <div className="tool-item">
                <LinkSvg className='icon' onClick={() => commonTabbarContext.navigate(TAB_TYPE.MONITOR_RELATION)} />
            </div>

            <DragModal
                title="图层管理"
                visible={showLayerManage}
                width={1000}
                mask
                destroyOnClose
                onClose={() => setShowLayerManage(false)}>
                <LayerManage />
            </DragModal>

            <DragModal
                title="UCS"
                visible={showUcsManage}
                width={400}
                mask
                destroyOnClose
                onClose={() => setShowUcsManage(false)}>
                <UcsManage />
            </DragModal>
        </div>
    )
}